"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global  BLE_Device */
/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "Revlis_CMATE" }]*/

var Revlis_cmate_reader = function (_BleReader) {
  _inherits(Revlis_cmate_reader, _BleReader);

  function Revlis_cmate_reader(device) {
    _classCallCheck(this, Revlis_cmate_reader);

    var _this = _possibleConstructorReturn(this, (Revlis_cmate_reader.__proto__ || Object.getPrototypeOf(Revlis_cmate_reader)).call(this, device));

    _this.command_uuid = "6e400002-b5a3-f393-e0a9-e50e24dcca9e";

    _this.commands = {
      get_version: btoa("VERSION\r\n"),
      get_total_files: btoa("TOTAL\r\n"),
      get_file_name: function get_file_name(index) {
        return btoa("NAME=" + index + "\r\n");
      },
      get_file_size: function get_file_size(index) {
        return btoa("SIZE=" + index + "\r\n");
      },
      get_file_time: function get_file_time(index) {
        return btoa("TIME=" + index + "\r\n");
      },
      delete_file: function delete_file(index) {
        return btoa("DEL=" + index + "\r\n");
      },
      start_file_download: function start_file_download(index) {
        return btoa("ULF=" + index + "\r\n");
      },
      continue_file_download: btoa("C"),
      ack_file_download: new Uint8Array([0x06]).buffer,
      nack_file_download: new Uint8Array([0x15]).buffer
    };

    _this.wait = {
      after_connection: 5000,
      between_data: 100
    };

    _this.reading = {
      fileIndex: null,
      fileSize: null,
      fileTime: null,
      fileName: null,
      packageIndex: 0,
      bytesWritten: 0,
      data: null,
      finished: false
    };

    return _this;
  }

  _createClass(Revlis_cmate_reader, [{
    key: "resetReading",
    value: function resetReading() {
      this.reading = {
        fileIndex: null,
        fileSize: null,
        fileTime: null,
        fileName: null,
        packageIndex: 0,
        bytesWritten: 0,
        data: null,
        finished: false
      };
    }
  }, {
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.resetReading();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onStartNotification",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(measurement_uuid) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.sleep(this.wait.after_connection);

              case 2:
                this.sendCommand(this.commands.get_total_files, "Get total Files.");

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onStartNotification(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onStartNotification;
    }()
  }, {
    key: "sendCommand",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(command, comment) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (comment) {
                  console.log(comment);
                }
                console.log("Sending command: " + command);

                return _context3.abrupt("return", this.write(this.service_uuid, this.command_uuid, command));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sendCommand(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return sendCommand;
    }()
  }, {
    key: "handleResult",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(result) {
        var byteArray, stringResult, percentDone;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // console.log( "got "+result.byteLength+" bytes");
                //console.log(  ByteArrayConverter.byteArrayToHex(result) );

                byteArray = new Uint8Array(result);

                if (!(byteArray[0] == 0x2B && byteArray[1] == 0x2A)) {
                  _context4.next = 37;
                  break;
                }

                stringResult = String.fromCharCode.apply(null, byteArray).trim();

                console.log("Received Command result: " + stringResult);

                if (!(stringResult.slice(2) == "ERR")) {
                  _context4.next = 8;
                  break;
                }

                console.log("Device Error.");
                this.failureCallback({ ok: false, error: "Device Error" });
                return _context4.abrupt("return");

              case 8:
                if (!(stringResult.slice(2) == "OK")) {
                  _context4.next = 11;
                  break;
                }

                console.log("registered 'OK' result");
                return _context4.abrupt("return");

              case 11:
                if (!(!isNaN(parseInt(stringResult.slice(2))) && this.reading.fileIndex == null)) {
                  _context4.next = 16;
                  break;
                }

                this.reading.fileIndex = parseInt(stringResult.slice(2)) - 1;
                console.log("Got latest file index: " + this.reading.fileIndex);
                this.sendCommand(this.commands.get_file_name(this.reading.fileIndex), "Get name of file #" + this.reading.fileIndex);
                return _context4.abrupt("return");

              case 16:
                if (!(this.reading.fileIndex != null && !this.reading.fileName && !this.reading.fileSize)) {
                  _context4.next = 21;
                  break;
                }

                this.reading.fileName = stringResult.slice(2);
                console.log("Got latest file name: " + this.reading.fileName);
                this.sendCommand(this.commands.get_file_size(this.reading.fileIndex), "Get size of file #" + this.reading.fileIndex);
                return _context4.abrupt("return");

              case 21:
                if (!(!isNaN(parseInt(stringResult.slice(2))) && this.reading.fileIndex != null && this.reading.fileName && !this.reading.fileSize)) {
                  _context4.next = 27;
                  break;
                }

                this.reading.fileSize = parseInt(stringResult.slice(2));
                console.log("Got file size: " + this.reading.fileSize + " bytes");
                this.reading.data = new Uint8Array(this.reading.fileSize);
                this.sendCommand(this.commands.get_file_time(this.reading.fileIndex), "Get timstamp of file #" + this.reading.fileIndex);
                return _context4.abrupt("return");

              case 27:

                if (!isNaN(parseInt(stringResult.slice(2))) && this.reading.fileIndex != null && this.reading.fileName && this.reading.fileSize && !this.reading.fileTime) {
                  this.reading.fileTime = this.decodeTime(parseInt(stringResult.slice(2)));
                  console.log("Got file time: " + this.reading.fileTime);
                }

                if (!(this.reading.fileIndex != null && this.reading.fileName && this.reading.fileSize && this.reading.fileTime)) {
                  _context4.next = 35;
                  break;
                }

                _context4.next = 31;
                return this.sleep(this.wait.between_data);

              case 31:
                console.log("Starting download of file #" + this.reading.fileIndex);
                _context4.next = 34;
                return this.sendCommand(this.commands.start_file_download(this.reading.fileIndex), "Start downloading file #" + this.reading.fileIndex);

              case 34:
                this.sendCommand(this.commands.continue_file_download, "Send continue command.");

              case 35:
                _context4.next = 58;
                break;

              case 37:
                if (!(byteArray.length == 1 && byteArray[0] == 0x04)) {
                  _context4.next = 43;
                  break;
                }

                //We got an EOT, the file is complete
                console.log("Received EOT. File complete.");
                this.reading.finished = true;
                this.finishUpload();
                _context4.next = 58;
                break;

              case 43:
                this.writeData(byteArray);
                //If this is the last package, send the ACK to get the next set of packages.

                if (!(this.reading.packageIndex == 52)) {
                  _context4.next = 58;
                  break;
                }

                console.log("Written " + this.reading.bytesWritten + " / " + this.reading.data.length + " bytes");
                percentDone = (this.reading.bytesWritten / this.reading.data.length * 100).toFixed(0);

                this.progressCallback({ message: $t("interviews.sensor_status.connected") + "  " + percentDone + "%", percent_done: percentDone });
                _context4.next = 50;
                return this.sleep(this.wait.between_data);

              case 50:
                this.reading.packageIndex = 0;
                console.log("Sending: Ack to dongle.");
                this.sendCommand(this.commands.ack_file_download);

                //Sometimes dongle will not send EOT so we disconnect after we are finished writing.

                if (!(this.reading.bytesWritten == this.reading.data.length)) {
                  _context4.next = 58;
                  break;
                }

                _context4.next = 56;
                return this.sleep(5000);

              case 56:
                this.reading.finished = true;
                this.finishUpload();

              case 58:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleResult(_x5) {
        return _ref4.apply(this, arguments);
      }

      return handleResult;
    }()
  }, {
    key: "finishUpload",
    value: function finishUpload() {
      console.log("Upload Finished.");
      console.log(this.reading.data);

      this.successCallback(this.formatResult());
    }
  }, {
    key: "writeData",
    value: function writeData(byteArray) {

      //Trim first 3 bytes if it's the first package
      if (this.reading.packageIndex == 0) {
        byteArray = byteArray.slice(3);
      }

      //Trim last 2 bytes if it's the last package
      if (this.reading.packageIndex == 51) {
        byteArray = byteArray.slice(0, -2);
      }

      //Don't write more bytes than expected in data array.
      //Trim the padding data out.
      if (this.reading.bytesWritten + byteArray.length > this.reading.data.length) {
        var bytesToTrim = this.reading.bytesWritten + byteArray.length - this.reading.data.length;
        byteArray = byteArray.slice(0, -bytesToTrim);
      }

      //Discard if we've written all our bytes.
      if (this.reading.bytesWritten >= this.reading.data.length) {
        console.log("Rec'd padding data from ECG. Discarding");
        // console.log(ByteArrayConverter.byteArrayToHex(byteArray));
      } else {
        //console.log("Received package " + this.reading.packageIndex);
        // console.log("Writing data: "+ByteArrayConverter.byteArrayToHex(byteArray));
        this.reading.data.set(byteArray, this.reading.bytesWritten);
        this.reading.bytesWritten += byteArray.length;
        //console.log("Written "+this.reading.bytesWritten+" / "+this.reading.data.length+" bytes")
      }
      this.reading.packageIndex++;
    }
  }, {
    key: "formatResult",
    value: function formatResult() {
      var reading = {
        valid: true,
        date: new Date(this.reading.fileTime),
        readings: [{ main: true,
          measurements: [{ name: "ecg_data", value: this.reading.data }]
        }]
      };

      return { ok: true, readings: reading, reader: this.name };
    }

    //Decodes time string (DWORD) 32 Bit.
    // Expects date in format 1227493829

  }, {
    key: "decodeTime",
    value: function decodeTime(time) {
      var binary_str_length = 32;
      var year_origin = 1980; //Device returns year - 1980.
      var seconds_factor = 2; //Device returns seconds/2 in binary.

      var date_binary_string = time.toString(2);

      if (date_binary_string.length < binary_str_length) {
        var length_diff = binary_str_length - date_binary_string.length;

        var padding_str = "";
        for (var i = 0; i < length_diff; i++) {
          padding_str += "0";
        }

        date_binary_string = padding_str + date_binary_string;
      }

      var year_bits = date_binary_string.substring(0, 7);
      var year = parseInt(year_bits, 2) + year_origin;

      var month_bits = date_binary_string.substring(7, 11);
      var month = parseInt(month_bits, 2);

      var day_bits = date_binary_string.substring(11, 16);
      var day = parseInt(day_bits, 2);

      var hour_bits = date_binary_string.substring(16, 21);
      var hour = parseInt(hour_bits, 2);

      var minute_bits = date_binary_string.substring(21, 27);
      var minute = parseInt(minute_bits, 2);

      var second_bits = date_binary_string.substring(27, 32);
      var second = parseInt(second_bits, 2) * seconds_factor;

      var date_string = year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second;

      return date_string;
    }
  }]);

  return Revlis_cmate_reader;
}(BleReader);

var Revlis_CMATE = new JS.Class(BLE_Device, {
  initialize: function initialize(device_uuid) {
    var name = "Revlis CMATE";
    var model_name = "CMATE";
    var service_uuid = "6e400001-b5a3-f393-e0a9-e50e24dcca9e";
    var measurement_uuids = ["6e400003-b5a3-f393-e0a9-e50e24dcca9e"];

    this.advertised_name = "Cmate-UBT";
    this.collectsBinaryData = true;

    return this.callSuper(name, model_name, device_uuid, service_uuid, measurement_uuids);
  },

  makeReader: function makeReader() {
    return new Revlis_cmate_reader(this);
  },

  readingWaitTime: function readingWaitTime() {
    return 5 * mymobileConfig.readings_timeout_seconds * 1000;
  }

});